export const CAT_EXECUTION_UPLOAD_CONSTANTS = {
  // Message severity
  SEVERITY_ERROR: 'error',

  // Summaries
  FILE_TOO_LARGE: 'File Too Large',
  MERGED_FILE_TOO_LARGE: 'Merged File Too Large',
  INVALID_FILE: 'Invalid File',
  PROCESSING_ERROR: 'Processing Error',

  // Details
  NOT_VALID_PDF: 'Not a valid PDF file. Please upload another one',
  SINGLE_EXTENSION_REQUIRED: 'File name should have only single extension',
  PDF_TOO_MANY_IMAGES:
    'contains too many images/tables. Base64 size exceeds 15MB. Please use a different PDF.',
  MERGED_PDF_TOO_LARGE:
    'Combined PDF contains too many images/tables. Base64 size exceeds 15MB. Please reduce the number of files or use smaller PDFs.',
  PDF_PROCESSING_ERROR: 'Error processing PDF files. Please try again.',
  TIMEOUT_ERROR: 'Timeout after 2 minutes',

  // Limits
  MAX_BASE64_SIZE_MB: 35,
  MAX_BASE64_SIZE_BYTES: 35 * 1024 * 1024,
  TIMEOUT_DURATION_MS: 120000,

  // Messages life
  MESSAGE_LIFE: 5000,
  SERVICE_TYPE_ESIGN: "E-Sign",
  SERVICE_TYPE_ESTAMP: "E-Stamp",
  SERVICE_TYPE_BOTH: "Both",
  ORDER_TYPE_PREPROCUREMENT: 'PRE_PROCUREMENT',
  ORDER_TYPE_ON_THE_FLY: 'ON_THE_FLY',
  ORDER_TYPE_ESBTR: 'ESBTR',
  BILLING_TYPE_PREPAID: 'PREPAID',
  BILLING_TYPE_POSTPAID: 'POSTPAID',

};
